import { budgetMonthSelector } from 'core/store/selectors/monthBudget.selector';
import { periodSelector } from 'core/store/selectors/period.selector';
import { useAppSelector } from './hooks';
import { currencies, defaultCurrency } from 'common/constants';
import { useCallback } from 'react';
import { Currency } from 'common/types';
import axiosClient from 'core/api/axiosClient';
import { endpoints } from 'core/api/endpoints';

export const useCurrency = () => {
  const budgetMonth = useAppSelector(periodSelector);
  const { currency: budgetMonthCurrency } = useAppSelector(
    budgetMonthSelector(budgetMonth)
  );

  const getExchangeRate = useCallback(
    async (from: Currency, to: Currency): Promise<number> => {
      if (from === to) return 1;
      const response = await axiosClient.get(
        `${endpoints.currency}?base=${from}&target=${to}`
      );
      return response.data && !isNaN(response.data) ? response.data : 1;
    },
    []
  );

  const sumWithCurrency = useCallback(
    (sum: number, customCurrency?: Currency): string => {
      const currencyData =
        currencies[customCurrency || budgetMonthCurrency || defaultCurrency];
      return currencyData.symbolPosition === 'after'
        ? `${sum.toFixed(2)} ${currencyData.symbol}`
        : `${currencyData.symbol} ${sum.toFixed(2)}`;
    },
    [budgetMonthCurrency]
  );
  return {
    currency: budgetMonthCurrency ?? defaultCurrency,
    sumWithCurrency,
    getExchangeRate
  };
};
